export const SANDBOX_CHANGE_COUNT_TOOLTIP =
  "Number of labor-model settings that differ between this Sandbox and the live published model. This counts model changes, not the percentage change in labor hours.";

export const SANDBOX_IMPACT_TOOLTIPS = {
  Earned:
    "Percentage change in earned labor hours for the evaluated stores and historical period: Sandbox hours calculated from actual sales compared with published earned hours. Positive means more hours; negative means fewer. This preview can also reflect updated operating data.",
  Forecasted:
    "Percentage change in forecasted labor hours for the evaluated stores and forecast period: Sandbox hours compared with published forecasted hours, using forecast sales. Positive means more hours; negative means fewer. This preview can also reflect updated operating data.",
};
